import React, { useState, useEffect, useRef, useContext } from "react";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AuthContext } from "../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useSessionHelper } from '../../../custom/sessionHelper';
import { openSessionModal } from '../../../store/sessionModalSlice';
import ConfirmationModalFakturaOvera from "../../../custom/ConfirmationModalFakturaOvera";
import handlePrintInvoice from './faktureStrane/fakturaStampa';
import { InputTextarea } from "primereact/inputtextarea";

const OveraFaktura = (props) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const formRef = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const invoice = useSelector(state => state.invoice);
  const { sessionHelper } = useSessionHelper();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; // ➜ stabilan ključ
  const [selectedRowId , setSelectedRowId] = useState(null);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [izabran, setIzabran] = useState(false)
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [popuni, setPopuni] = useState(false);
  const [idInvoice, setIdInvoice] = useState(null);
  
  
  const [confirmVisible, setConfirmVisible] = useState(false); 
  //Data
  const [formData, setFormData] = useState({
    NapomenaProvera: ""
  })

  // Path normalization and document location helper
  const getDocumentLocation = (path) => {
    if (!path) return null;
    
    // Normalize Windows path to URL format
    const normalizedPath = path.replace(/\\/g, '/');
    
    // Remove full C:/Dokumenta/ from path
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const getConfigColumns = async () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 311
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

     if(data.length > 0) {
                    return { empty: false, data: data };
                } else {
                    return { empty: true, data: [] };
                }


};

  useEffect(() => {

    if(!formSubmitted) {
      if(invoice) {
        dispatch({
          type: "INVOICE",
          value: null
         });
    }
    
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        tip: 303,
        pregled: 'OVERA'
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/GetALLInvoicesData", requestOptions)
      .then(handleErrors)
      .then(async (data) => {

        setTableData(data);

            dispatch({
                        type: "COUNTER_INVOICE_CHECK",
                        value:
                          data.length
                      });  
        
        // Extract all available columns from the first data row
            if (data && data.length > 0) {
        const columns = Object.keys(data[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
            label: key,
            value: key
            }));
  

          setAllColumns(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrder(originalOrder);
          
          const columnsDB = await getConfigColumns();

              if (!columnsDB.empty && columnsDB.data.length > 0) {
                const arr = JSON.parse(columnsDB.data[0].parametri);
                setSelectedColumns(arr);
              } else {
                setSelectedColumns(columns.slice(0, 5).map(col => col.value));
              }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
    }
  }, [auth.token, company.companyId, formSubmitted]);


  const handleEditInvoice = (id) => {
    
        confirmDialog({
          message: "Jel ste sigurni da želite nastaviti sa editovanjem fakture?",
          acceptLabel: "Da",
          rejectLabel: "Ne",
          icon: "pi pi-info-circle",
          acceptClassName: "p-button-danger",
          accept: () => acceptEdit(id),
          reject: rejectEdit,
        });
  }

  const acceptEdit = (id) => {
    //Ovde dodati kod za editovanje i stavljanje overe
    props.setIdInvoice(id.Izaberi)
  }

  const rejectEdit = () => {
    //Ovde dodati kod za editovanje i stavljanje odbijenice
        setIzabran(false);
        dispatch({ type: "INVOICE", value: null });
        setSelectedRowId(null)
  }

  
  const chooseInvoice = async (rowData) => { 
    
     const id = getId(rowData);

       let resultSession = await sessionHelper(user.userId,'IFOVERA', id)
  
      if(resultSession.zauzeto) {
                  dispatch(openSessionModal({
                    type: "SESSION_LOCK",
                    message: resultSession.message
                  }));
                  return
      }

    setSelectedRowId((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

      
    if (next) {
      // selekcija
      const invoiceID = tableData?.find(t => String(t.Izaberi) === String(rowData.Izaberi));
      if (invoiceID) {
    
        setIzabran(true);
      }
      dispatch({ type: "INVOICE", value: rowData.Izaberi });
      setConfirmVisible(true)
      popuniRedove(invoiceID.Izaberi)
    } else {
      setIzabran(false);
      dispatch({ type: "INVOICE", value: null });
    }

    return next;
  });
  }


   const previewBodyTemplate = (rowData, field) => {
    const filePathsString = rowData[field];
    if (!filePathsString) return '-';
  
       if(field == 'Izaberi') {
    
          const selected = isSelected(rowData);
           return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Button
                        label='Izaberi'
                        icon="pi pi-eye"
                        className="p-button-text p-button-sm"
                        onClick={(e) => chooseInvoice(rowData)}
                        tooltip="Izaberi fakturu za dalji rad"
                        tooltipOptions={{ position: 'top' }}
                      />
                    
                </div>
              );
       } else {

    const filePaths = filePathsString.split('|').filter(p => p.trim() !== '');
  
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {filePaths.map((path, idx) => {
          const documentUrl = getDocumentLocation(path);
          if (!documentUrl) return null;
  
          // Izdvoji ime fajla bez ekstenzije
          const fileNameWithExt = path.split('/').pop(); // npr. TOI-Psihologija-2016-testkljuc_20250726222909703.pdf
          const fileName = fileNameWithExt.replace(/\.(pdf|jpg|png)$/i, '');
  
          return (
            <Button
              key={idx}
              label={fileName}
              icon="pi pi-eye"
              className="p-button-text p-button-sm"
              onClick={() => window.open(documentUrl, '_blank')}
              tooltip="Pregledaj dokument"
              tooltipOptions={{ position: 'top' }}
            />
          );
        })}
      </div>
    ); }
  };

  const isFileColumn = (field) => {
    return field.startsWith('Prilozi') || 
           field.includes('Izaberi') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

const exportExcel = async () => {
    if (!selectedColumns || selectedColumns.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Izlazna fakture - Avans');

    // Use selectedColumns instead of all table keys
    const headers = selectedColumns;

    // Add header row
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
        };
        cell.border = {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
        };
    });

    // Add filtered data rows
    tableData.forEach((rowData) => {
        const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Auto-size columns
    worksheet.columns.forEach((column, i) => {
        const lengths = [
            headers[i].length,
            ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
        ];
        column.width = Math.max(...lengths) + 2;
    });

    // Serbian-formatted datetime
    const date = new Date();
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Belgrade'
    };
    const serbianDateTime = date.toLocaleString('sr-RS', options)
        .replace(/\s/g, ' ')
        .replace(/,/g, '');

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Izlazne fakture Avans - ${company.companyName} - ${serbianDateTime}.xlsx`);
};
     const header = (
        <div className="export-buttons fakture-stavke-header">
            <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
            </div>
            <input type="search" placeholder={t('nova.phPretraga')}
                className="p-inputtext p-component"
                onInput={(e) => setGlobalFilter(e.target.value)} />
        </div>
    );

  const handleSaveConfig = () => {
         confirmDialog({
                    message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                    acceptLabel: "Da",
                    rejectLabel: "Ne",
                    icon: "pi pi-info-circle",
                    acceptClassName: "p-button-danger",
                    accept: acceptInsertConfig,
                    reject: rejectInsertConfig,
                    });
  }

  const acceptInsertConfig  = () => {
    if(selectedColumns.length > 0) {
       let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_config: 311,
        parametri: selectedColumns
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
      .then(handleErrors)
      .then((data) => {


          if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: data.message,
                    life: 3000,
                    });
                return
                }  
  
            toast.current.show({
                severity: "success",
                summary: "Uspešna izmena konfiguracije pregleda za izlazne fakture - Overa!",
                life: 3000,
            });

      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
    } else {
        toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Morate imati barem 1 izabranu stavku!",
                    life: 3000,
                    });
    }
     
  }
  const rejectInsertConfig = () => {
    console.log('Config insert rejected!')
  }

  const resetData = () => {
    setFormData({
      NapomenaProvera: ""
    })
    setInvoiceData(null)
  }

    const popuniStavke = (apiData) => {
    setFormData({
        NapomenaProvera: apiData.NapomenaProvera || ''
    });
}

    const popuniRedove = async (id) => {

             setPopuni(true);
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/FillInInvoiceCheckData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                              setInvoiceData(data?.[0])  
                              popuniStavke(data?.[0])
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
          
    }

  const handleChange = (e) => {
    const { name, value } = e.target || e;

    if (name in formData) {
        setFormData(prev => ({ ...prev, [name]: value}));
    }
  };

    const handleFormSubmit = (x) => {
    
                    setFormSubmitted(true)
                if (formRef.current && !formRef.current.checkValidity()) {
                    formRef.current.reportValidity(); // prikazuje native browser poruke
                    return;
                }
       saveItems(x)
     }

    const saveItems = (x) => {
  
      confirmDialog({
        message: `Jel ste sigurni da želite ${x ? 'PRIHVATITI' : 'ODBITI'} fakturu?`,
        acceptLabel: "Da",
        rejectLabel: "Ne",
        icon: "pi pi-info-circle",
        acceptClassName: "p-button-danger",
        accept: () => acceptSaveItems(x),
      });
    };
  
    const acceptSaveItems = async (x) => {
  
      try {
  
              if(selectedRowId){
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  confirm: x,
                                  id: Number(selectedRowId),
                                  formData
                              }),
                          };
                  
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/UpdateInvoiceConfirm", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
  
                                 if(data[0].message && data[0].message != 'Nema izmena u podacima fakture.'){
                                      toast.current.show({
                                      severity: "error",
                                      summary: "Error",
                                      detail: data[0].message,
                                      life: 3000,
                                      });
                                      return
                                  }  
  
                                  if(data[0].message == 'Nema izmena u podacima fakture.'){
                                  toast.current.show({
                                  severity: "warn",
                                  summary: data[0].message,
                                  life: 3000,
                                  });
                                  
                                  } else {
                                  toast.current.show({
                                  severity: "success",
                                  summary: "Uspešna izmena podataka fakture za proveru!",
                                  life: 3000,
                                  });
                                  resetData()
                                  setIzabran(false)
                                  setSelectedRowId(null)
                                  setFormSubmitted(false)
                                  setInvoiceData(null)
                                  setConfirmVisible(false)
                                  }  
                                 
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({ 
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
             
              } else {  
                      toast.current.show({
                      severity: "warn",
                      summary: "Upozorenje!",
                      detail: "Nije mogući unos overe, nije uspešno vezana za fakturu!",
                      life: 3000,
                    });         
              }
      } catch (err) {
        toast.current?.show({
          severity: "error",
          summary: "Greška",
          detail: "Neuspešno čuvanje overe.",
          life: 3000,
        });
      }
    };

     const handleStampaj = () => {
         if(selectedRowId) {
                  let requestOptions = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token,
                  },
                  body: JSON.stringify({
                    id: selectedRowId,
                    QR: invoiceData?.id_podtip_fakture === 305
                  }),
                };
                
                fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/PrintInvoice", requestOptions)
                  .then(handleErrors)
                  .then((data) => {

                    if(data && data.htmlContent){
                      handlePrintInvoice(data)
                    }

                  })
                  .catch((error) => {
                    error.json().then((errorMessage) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: errorMessage.message,
                        life: 3000,
                      });
                      console.log(errorMessage);
                    });
                  });
                } else {
                   toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali fakturu kako bi je štampali!",
                        life: 3000,
                      });
                }
      }

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
                  <ConfirmationModalFakturaOvera
                visible={confirmVisible}
                onHide={() => {setConfirmVisible(false);setIdInvoice(null);setInvoiceData(null);setIzabran(false);setSelectedRowId(null)}}
                onConfirmPrint={handleStampaj}
                onConfirmValidate={() => {handleFormSubmit(true)}}
                onConfirmReject={() => {handleFormSubmit(false)}}
                idInvoice={selectedRowId}
            >
              <form autoComplete="off" ref={formRef}  style={{ display:'flex', flexWrap: 'wrap' }}>
                <div className="col-12 stavkaField" style={{flexDirection:'column',maxWidth:'100%'}}>
                  <label htmlFor="BrojFakture" style={{marginRight:'2%'}}>
                    Broj fakture:
                  </label>
                 <span style={{fontWeight:'700'}}>{invoiceData ? invoiceData.BrojFakture : ''}</span>
                </div>
                <div className="col-12 stavkaField" style={{flexDirection:'column',maxWidth:'100%'}}>
                  <label htmlFor="NapomenaProvera">
                    Napomena:
                  </label>
                  <InputTextarea
                    id="NapomenaProvera"
                    name="NapomenaProvera"
                    value={formData.NapomenaProvera}
                    onChange={handleChange}
                    rows={3}
                  />
                </div>
            </form>
          </ConfirmationModalFakturaOvera>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <div style={{ width: "20%" }}>
          {allColumns.length > 0 && (
            <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>  <MultiSelect
              value={selectedColumns}
              options={allColumns}
              onChange={(e) => {
            const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
            setSelectedColumns(sorted);
          }}
              optionLabel="label"
              display="chip"
              placeholder={t('nova.odaberiteKolone')}
              style={{ width: '100%' }}
              showSelectAll={true}
              filter
              filterPlaceholder="Pretraži kolone"
              maxSelectedLabels={3}
              selectedItemsLabel="{0} kolona odabrano"
            />
            <button onClick={handleSaveConfig} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div>
          )}
          
        </div>
        {(izabran) && <p class="infoPoruka" style={{margin: '0', display: 'flex', alignItems: 'center'}}>Izlazna faktura je selektovana. Moguće ažuriranje njegovih podataka.</p>}
      </div>
     
      <Tooltip target=".export-buttons>button" position="bottom" />
      <DataTable
        value={tableData}
        paginator
        rows={10}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        header={header}
        className="stavke-tabela"
        scrollHeight="600px"
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
      >
        {selectedColumns.map((colKey) => {
        const colMeta = allColumns.find(col => col.value === colKey);
        return (
          <Column
            key={colKey}
            field={colKey}
            header={colMeta?.label || colKey}
            sortable
            body={(rowData) => {
              if (isFileColumn(colKey)) {
                return previewBodyTemplate(rowData, colKey);
              }
              return rowData[colKey] || '-';
            }}
            style={{ minWidth: '150px'}}
          />
        );
      })}
      </DataTable>
    </div>
  );
};

export default OveraFaktura;